import React from "react";

export default function ARTICLE_2024_02_19_ANTENNA_ORIENTATION(props) {

    return (
        <div className='content'>

            <h1>Antenna Orientation</h1>

            <p>
                The first thing to know about antenna orientation is that antenna work best when they are oriented
                parallel to each other.  This is because the antenna is designed to receive and transmit signals in a
                specific direction.  If the antenna is not oriented in the same direction, the signal will be weaker and
                the range will be reduced.  This is why it is important to orient the antenna in the same direction as
                the transmitter.
            </p>

            <p>
                It is most common to orient the antenna vertically on the transmitter.  This is because the signal is
                transmitted in all directions.  If the antenna on the aircraft is oriented in the same direction
                as the transmitter, the signal will be stronger and the range will be greater.
            </p>

            <p>
                If you have a receiver with two antennas, it is best to orient them at a 90 degree angle to each other.
                This ensures that at least one antenna is not perpendicular to the transmitter.  This arrangement is
                best for aircraft that maneuver in all directions.
            </p>

        </div>
    )

}

